export function getNonce(): string {
  return getNonceFromCSPHeader();
}

const getNonceFromCSPHeader = () => {
  return document.querySelector('meta[name="csp-nonce"]')?.getAttribute('value');
};
